module.exports = __webpack_public_path__ + "static/loader-cb7cbc0b130e024b8d81f8921c64e0b9.gif";